import { ROUTES, history } from 'Utils/constants'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import analytics from 'shared/Analytics'
import { COTIZACION_REMOVE, LOGOUT_USER } from 'redux/types'
import { notifyAuthLogout } from 'Utils/authSessionSync'
import {
  clearCustomerDisplayOwnerTabId,
  getCustomerDisplayTabId,
} from 'Views/CustomerDisplay/utils/customerDisplayChannel'

export const clearLocalSession = (
  dispatch,
  // BrowserRouter keeps its own history; Utils/constants history does not
  // track in-app navigation, so callers inside the Router must pass theirs.
  { redirectToLogin = true, navigationHistory = history } = {}
) => {
  // Clear this tab's ownership before Redux changes can mount the next login
  // flow. Other tabs release their own ownership when they get the logout.
  try {
    clearCustomerDisplayOwnerTabId(getCustomerDisplayTabId())
  } catch (error) {
    console.warn(
      'No se pudo limpiar la conexión de Customer Display al cerrar sesión:',
      error
    )
  }

  dispatch({ type: LOGOUT_USER })
  dispatch({ type: COTIZACION_REMOVE })

  if (redirectToLogin && navigationHistory.location.pathname !== ROUTES.login) {
    navigationHistory.push(ROUTES.login)
  }

  return Promise.resolve()
    .then(() => analytics.pause())
    .catch(error => {
      console.warn('No se pudo pausar Analytics al cerrar sesión:', error)
    })
}

export const useLogout = () => {
  const dispatch = useDispatch()
  const routerHistory = useHistory()

  const logout = async () => {
    notifyAuthLogout()
    await clearLocalSession(dispatch, { navigationHistory: routerHistory })
  }

  return { logout }
}
